import {configure, getStorybookUI} from '@storybook/react-native';

import {AsyncStorage} from '/util/async-storage';

import './rn-addons';

configure(() => {
  require('./stories');
}, module);

const StorybookUIRoot = getStorybookUI({
  // @ts-expect-error TS(2345): Argument of type '{ asyncStorage: AsyncStorageStat... Remove this comment to see the full error message
  asyncStorage: AsyncStorage,
  shouldDisableKeyboardAvoidingView: true,
});

export default StorybookUIRoot;
